import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import MobileBottomNav from "@/components/feature/MobileBottomNav";
import MovieCard from "@/components/feature/MovieCard";
import { movies, featuredIds } from "@/mocks/movies";
import HeroCarousel from "./components/HeroCarousel";
import SectionHeading from "./components/SectionHeading";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import TopicCollections from "./components/TopicCollections";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  const featured = featuredIds
    .map((id) => movies.find((m) => m.id === id))
    .filter((m): m is NonNullable<typeof m> => Boolean(m));

  const latest = [...movies]
    .sort((a, b) => b.year - a.year || b.popularity - a.popularity)
    .slice(0, 8);

  const hot = [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 8);

  const popularMovies = [...movies]
    .filter((m) => m.type === "movie")
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 6);

  const hotDramas = [...movies]
    .filter((m) => m.type === "drama")
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 6);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader overlay />

      <main className="flex-1 pb-16 md:pb-0">
        <HeroCarousel movies={featured} />

        {/* 分类快捷入口 */}
        <section className="px-4 md:px-8 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto">
            <SectionHeading title="按类型浏览" subtitle="快速进入你想看的影视类型" />
            <CategoryQuickLinks />
          </div>
        </section>

        {/* 最新上线 */}
        <section className="px-4 md:px-8 py-10 md:py-14 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <SectionHeading
              title="最新上线"
              subtitle="近期更新的电影与电视剧作品"
              moreTo="/category/movie"
            />
            {latest.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
                {latest.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <p className="py-12 text-center text-foreground-500">暂无推荐影视</p>
            )}
          </div>
        </section>

        {/* 热门影视 */}
        <section className="px-4 md:px-8 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto">
            <SectionHeading
              title="热门影视"
              subtitle="观众关注度最高的影视作品"
              moreTo="/search"
              moreLabel="去搜索"
            />
            {hot.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
                {hot.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <p className="py-12 text-center text-foreground-500">暂无推荐影视</p>
            )}
          </div>
        </section>

        {/* 影视专题专栏 */}
        <section className="px-4 md:px-8 py-10 md:py-14 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <SectionHeading title="影视专题专栏" subtitle="为你整理的口碑榜单与热门合集" />
            <TopicCollections popular={popularMovies} hotDramas={hotDramas} />
          </div>
        </section>

        {/* 网站简介及联系方式 */}
        <section id="intro" className="px-4 md:px-8 py-10 md:py-16">
          <div className="max-w-[1280px] mx-auto">
            <SiteIntro />
          </div>
        </section>

        {/* 行动引导 */}
        <section className="px-4 md:px-8 pb-12 md:pb-16">
          <div className="max-w-[1280px] mx-auto">
            <div className="relative overflow-hidden rounded-lg bg-primary-950 px-6 py-10 md:px-12 md:py-14">
              <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                <div>
                  <h2 className="font-heading font-black text-background-50 text-xl md:text-3xl">
                    还没想好今晚看什么？
                  </h2>
                  <p className="mt-2 text-background-300 text-sm md:text-base">
                    输入片名或关键词，快速找到你想了解的影视作品。
                  </p>
                </div>
                <Link
                  to="/search"
                  className="shrink-0 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors"
                >
                  <i className="ri-search-line"></i>
                  搜索影视作品
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
      <MobileBottomNav />
    </div>
  );
}